import { createSlice } from "@reduxjs/toolkit";
import { confirmDelivery } from "../../apis/dispense/confirmDelivery";
import { extractNestedApiErrorMessage } from "../../../utils/helper/apiErrorMessage";

const initialState = {
	loading: false,
	data: null,
	error: null,
	userFacingErrorMessage: null,
}

const pickUserFacingMessage = (payload) => {
	if (payload && typeof payload === 'object' && 'userFacingMessage' in payload) {
		const m = payload.userFacingMessage;
		return typeof m === 'string' && m.trim() ? m.trim() : null;
	}
	if (payload?.data) {
		return extractNestedApiErrorMessage(payload.data) || null;
	}
	return null;
}

const confirmDeliverySlice = createSlice({
	name: 'confirmDelivery',
	initialState,
	reducers: {
		clearConfirmDeliveryUserMessage(state) {
			state.userFacingErrorMessage = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(confirmDelivery.pending.type, (state) => {
			return {
				...state,
				loading: true,
				data: null,
				error: null,
				userFacingErrorMessage: null,
			}
		})

		builder.addCase(confirmDelivery.fulfilled.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
				userFacingErrorMessage: null,
			}
		})

		builder.addCase(confirmDelivery.rejected.type, (state, action) => {
			const payload = action.payload;
			const userFacing = pickUserFacingMessage(payload);
			const innerError = payload && typeof payload === 'object' && 'inner' in payload
				? payload.inner
				: payload;
			return {
				...state,
				loading: false,
				data: null,
				error: innerError ?? null,
				userFacingErrorMessage: userFacing,
			}
		})
	}

})

export const { clearConfirmDeliveryUserMessage } = confirmDeliverySlice.actions;
export default confirmDeliverySlice.reducer;
